if (!customElements.get('product-form')) {
  customElements.define('product-form', class ProductForm extends HTMLElement {
    constructor() {
      super();

      this.form = this.querySelector('form');
      this.form.querySelector('[name=id]').disabled = false;
      this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
      this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
      this.submitButton = this.querySelector('[type="submit"]');
      if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

      this.hideErrors = this.dataset.hideErrors === 'true';
    }

    onSubmitHandler(evt) {
      evt.preventDefault();
      if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

      this.handleErrorMessage();

      this.submitButton.setAttribute('aria-disabled', true);
      this.submitButton.classList.add('loading');
      this.querySelector('.loading-overlay__spinner').classList.remove('hidden');

      const config = fetchConfig('javascript');
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      delete config.headers['Content-Type'];

      const formData = new FormData(this.form);
      const quickAddModal = this.closest('quick-add-modal');
      const cartTrigger = quickAddModal?.openedBy || this.submitButton;
      const cartOrigin = window.CandyPeakOwnedCart?.captureAddOrigin(cartTrigger);
      const productScope = this.closest('.product') || this.closest('product-info') || quickAddModal;
      const productImage = productScope?.querySelector('.product__media-item.is-active img') || productScope?.querySelector('.product__media-item[aria-current="true"] img') || productScope?.querySelector('.product__media img');
      const feedbackContext = {
        image: productImage?.complete && productImage.naturalWidth ? productImage.currentSrc || productImage.src : productImage?.src || '',
        title: productScope?.querySelector('.product__title h1,.product__title h2,h1')?.textContent?.trim() || '',
        variantId: formData.get('id'),
        quantity: Number(formData.get('quantity') || 1)
      };
      const cartFeedback = this.cart?.classList.contains('cp-owned-cart')
        ? window.CandyPeakOwnedCart?.beginAddFeedback(this.submitButton, cartOrigin, feedbackContext) : undefined;
      let addConfirmed = false;
      if (this.cart) {
        if (!this.cart.classList.contains('cp-owned-cart')) {
          formData.append('sections', this.cart.getSectionsToRender().map((section) => section.id));
          formData.append('sections_url', window.location.pathname);
        }
        this.cart.setActiveElement(cartTrigger);
      }
      config.body = formData;

      fetch(`${routes.cart_add_url}`, config)
        .then(async (response) => {
          const result = await response.json();
          if (!response.ok && !result.status) result.status = response.status;
          return result;
        })
        .then((response) => {
          if (response.status) {
            window.CandyPeakOwnedCart?.cancelAddFeedback(cartFeedback);
            publish(PUB_SUB_EVENTS.cartError, {source: 'product-form', productVariantId: formData.get('id'), errors: response.description, message: response.message});
            this.handleErrorMessage(response.description);

            const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
            if (!soldOutMessage) return;
            this.submitButton.setAttribute('aria-disabled', true);
            this.submitButton.querySelector('span').classList.add('hidden');
            soldOutMessage.classList.remove('hidden');
            this.error = true;
            return;
          } else if (!this.cart) {
            window.location = window.routes.cart_url;
            return;
          }

          addConfirmed = true;
          if (!this.error) publish(PUB_SUB_EVENTS.cartUpdate, {source: 'product-form', productVariantId: formData.get('id'), cpOwnedCartManaged: this.cart.classList.contains('cp-owned-cart')});
          this.error = false;
          if (this.cart.classList.contains('cp-owned-cart')) {
            if (quickAddModal) quickAddModal.hide(true);
            this.cart.renderContents(response, cartTrigger, cartOrigin, cartFeedback);
          } else if (quickAddModal) {
            document.body.addEventListener('modalClosed', () => {
              setTimeout(() => { this.cart.renderContents(response, cartTrigger, cartOrigin) });
            }, { once: true });
            quickAddModal.hide(true);
          } else {
            this.cart.renderContents(response, cartTrigger, cartOrigin);
          }
        })
        .catch((e) => {
          window.CandyPeakOwnedCart?.cancelAddFeedback(cartFeedback);
          this.handleErrorMessage(e?.description || window.cartStrings?.error || 'Cart error');
          console.error(e);
        })
        .finally(() => {
          this.submitButton.classList.remove('loading');
          if (addConfirmed && this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
          if (!this.error) this.submitButton.removeAttribute('aria-disabled');
          this.querySelector('.loading-overlay__spinner').classList.add('hidden');
        });
    }

    handleErrorMessage(errorMessage = false) {
      if (this.hideErrors) return;

      this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
      if (!this.errorMessageWrapper) return;
      this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

      this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

      if (errorMessage) {
        this.errorMessage.textContent = errorMessage;
      }
    }
  });
}


